export { default } from './ByExp';



// WEBPACK FOOTER //
// ./src/components/TopUsers/ByExp/index.js